"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckboxInput = function CheckboxInput(props) {
  var labelBefore = props.labelBefore ? /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: props.id,
    className: 'no-box'
  }, props.labelBefore) : '';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox"
  }, /*#__PURE__*/_react.default.createElement("input", {
    id: props.id || props.name,
    name: props.name,
    onChange: props.onChange,
    checked: !!props.value,
    disabled: props.disabled,
    type: "checkbox"
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "checkbox__label",
    htmlFor: props.id || props.name
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'checkbox__label--inner'
  }, props.label), labelBefore));
};

CheckboxInput.propTypes = {
  name: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func,
  value: _propTypes.default.any,
  label: _propTypes.default.string.isRequired,
  id: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  labelBefore: _propTypes.default.string
};
var _default = CheckboxInput;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/form-inputs/checkbox.js
// module id = 510
// module chunks = 0